import http from "@/service";
import type { MenuItem } from "@/types/system/menu";
import { SelectTreeType } from "@/types";
const api = {
  menuList: "/pac-system/menu/list",
  menuListByRole: "/pac-system/menu/routes",
  addOrUpdate: "/pac-system/menu/submit",
  deleteMenu: "/pac-system/menu/remove",
  getMenuDetail: "/pac-system/menu/detail",
  getMenuTree: "/pac-system/menu/tree",
  getButtonAuth: "/pac-system/menu/buttons"
};

export function fetchMenuList(params?: any) {
  return http.get<MenuItem[]>(api.menuList, { params });
}

export function fetchMenuByRole(params?: any) {
  return http.get<MenuItem[]>(api.menuListByRole, { params });
}

export function addOrUpdateMenu(menu: any) {
  return http.post<any>(api.addOrUpdate, menu);
}

export function deleteMenu(ids: string) {
  return http.delete<any>(api.deleteMenu, null, {
    params: { ids }
  });
}

export function getMenuDetail(id: string) {
  return http.get<any>(api.getMenuDetail, { params: { id } });
}

export function getMenuTree() {
  return http.get<SelectTreeType[]>(api.getMenuTree);
}

export function fetchButtonByRole() {
  return http.get<MenuItem[]>(api.getButtonAuth);
}
